export default "__VITE_ASSET__BjAwO$Fl__"